<template>
  <div class="diversity-report-wrap">
    <!-- <DiversityTopBar
      ref="rateTopBar"
      @toggleReportFilter="toggleReportFilter"
      @resetReportFilters="resetReportFilters"
      @reportDateFilters="reportDateFilters"
    ></DiversityTopBar> -->

    <analytics-topbar
      title="Gender-wise engagement analysis"
      :isFilterApplied="isFilterApplied"
      @toggleReportFilter="toggleReportFilters"
      @resetDashFilters="resetDashFilters"
    ></analytics-topbar>
    <v-row class="diversity-report-heading mx-4">
      <v-col cols="12">
        <div class="diversity-report-title">
          Gender-wise engagement analysis
        </div>
        <div class="diversity-report-sub">
          This report represents the engagement analysis of different genders over time.
        </div>
      </v-col>
    </v-row>
    <div class="report-container">
      <div class="report-wrap">
        <div class="bar-wrap">
          <div class="report-bar-graph intro-x">
            <diversityOvertimeStats
              :stats-data="overallEngagements"
            ></diversityOvertimeStats>
            <diversityOvertimeBar
              :bar-data="overtimeBarData"
              :sort-by-key="sortByKey"
            ></diversityOvertimeBar>
          </div>
          <div class="overtime-table">
            <v-row class="diversity-report-heading mx-4">
              <v-col cols="12">
                <div class="diversity-report-title">
                  Month-wise engagement score across demographics
                </div>
                <div class="diversity-report-sub">
                  Measure the gender engagement score across demographics.
                </div>
              </v-col>
            </v-row>
            <diversityOvertimeTable
            :reportDates="reportDates"
            :sort-by-data="sortOptions"
            :tableData="overtimeTableData"
            @onClickSortByOvertime="onClickSortByOvertime"
            ></diversityOvertimeTable>
          </div>
          <div class="driver-reports">
            <v-row class="diversity-report-heading mx-4">
              <v-col cols="12">
                <div class="diversity-report-title">
                  Gender-wise engagement driver's performance
                </div>
                <div class="diversity-report-sub">
                  This report represents the driver's performance gender-wise. This is useful to identify which drivers/sub drivers are working well and what needs to be improved.
                </div>
              </v-col>
            </v-row>
            <div class="report-bar-graph intro-x" style="height:550px;">
              <diversityDriverStats
              :stats-data="overallParticipation"
            ></diversityDriverStats>
              <diversityDriverBar
              :bar-data="driverBarData"
              ></diversityDriverBar>
            </div>
            <div class="driver-table">
              <v-row class="diversity-report-heading mx-4">
                <v-col cols="12">
                  <div class="diversity-report-title">
                    Driver's performance across demographics
                  </div>
                  <div class="diversity-report-sub">
                    Compare gender-wise performance of the drivers across different demographics.
                  </div>
                </v-col>
              </v-row>
              <diversityDriverTable
                :reportDrivers="reportDrivers"
                :sort-by-data="sortOptions"
                :tableData="driverTableData"
                @onClickSortByDrivers="onClickSortByDrivers"
              ></diversityDriverTable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="reportFilterDrawer">
      <!-- <reportFilters
        ref="ReportFilters"
        reportType="gender_diversity"
        @dashFiltersApplied="dashFiltersApplied"
      ></reportFilters> -->
      <reportFilters
        ref="ReportFilters"
        reportType="gender_diversity"
        @getReportWithFilter="filterApplied"
      ></reportFilters>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { format, subDays } from 'date-fns';
import AnalyticsTopbar from './analytics-topbar';
// import DiversityTopBar from './diversity-component/diversity-top-bar';
import DiversityOvertimeStats from './diversity-component/diversity-overtime-stats';
import DiversityDriverStats from './diversity-component/diversity-driver-stats';
// import DiversitySortByNav from './diversity-component/diversity-sort-by-nav';
import DiversityOvertimeBar from './diversity-component/diversity-overtime-bar';
import DiversityOvertimeTable from './diversity-component/diversity-overtime-table';
import DiversityDriverBar from './diversity-component/diversity-driver-bar';
// import DiversityDriverDonught from './diversity-component/diversity-driver-donught';
import DiversityDriverTable from './diversity-component/diversity-driver-table';
import ReportFilters from './analytics-filters';

import AnalyticsMixin from './analytics-mixin';

export default {
  name: 'DiversityReport',

  mixins: [AnalyticsMixin],

  components: {
    // DiversityTopBar,
    ReportFilters,
    AnalyticsTopbar,
    DiversityOvertimeStats,
    // DiversitySortByNav,
    DiversityOvertimeBar,
    DiversityDriverStats,
    DiversityOvertimeTable,
    DiversityDriverBar,
    // DiversityDriverDonught,
    DiversityDriverTable
  },

  data () {
    return {
      isFilterApplied: false,
      sortOptions: {},
      // sortByData: [],
      // sortOptions: {
      //   location: 'Location',
      //   site: 'Site',
      //   department: 'Department',
      //   gender: 'Gender',
      //   business: 'Business',
      //   grade: 'Grade',
      //   hrbp: 'HR Business Partner',
      //   hr_manager: 'HR Manager',
      //   cluster: 'Cluster',
      // },
      filterOptions: {},
      chartData: {
        default: [],
        selected: []
      },
      sortByKey: '',
      selectedfilters: [],
      reportDate: {
        start: format(subDays(new Date(), 365), 'yyyy-MM-dd'),
        end: format(new Date(), 'yyyy-MM-dd')
      },
      trendsData: {
        default: [],
        selected: {}
      },
      overtimeBarData: {},
      overallEngagements: {},
      overallParticipation: {},
      overtimeTableData: {},
      driverBarData: {},
      driverTableData: {},
      reportDates: [],
      reportDrivers: []
    };
  },

  computed: {
    ...mapState({
      user: state => state.user,
      updateReportFilters: state => state.updateReportFilters
    })
  },
  created () {
    // this.getSortOptions();
    // this.getDiversityReport();
    this.$store.dispatch('updateReportFilters', null);
  },
  watch: {
    updateReportFilters: {
      immediate: true,
      deep: true,
      handler () {
        this.getDiversityReport();
      }
    }
  },
  methods: {
    // sortOptions (val) {
    //   this.sortByData = val;
    // },
    resetDashFilters () {
      this.isFilterApplied = false;
      this.$refs.ReportFilters.resetFilters();
    },
    toggleReportFilters () {
      this.$refs.ReportFilters.showFilterDrawer = true;
    },
    dashFiltersApplied (val) {
      this.isFilterApplied = val;
    },
    filterApplied (val) {
      this.isFilterApplied = val;
      this.getDiversityReport();
    },
    onClickSortByOvertime (val) {
      console.log(this.updateReportFilters);
      const queryParams = {
        sort_key: val || undefined,
        fields: 'datewise_sorted_report',
        initiated_date_start: this.updateReportFilters && this.updateReportFilters.initiated_date_start ? this.updateReportFilters.initiated_date_start : undefined,
        initiated_date_end: this.updateReportFilters && this.updateReportFilters.initiated_date_end ? this.updateReportFilters.initiated_date_end : undefined,
        // initiated_date_start: this.reportDate.start,
        // initiated_date_end: this.reportDate.end,
        user__profile__high_potential_emp: this.updateReportFilters && this.updateReportFilters.high_potential_emp ? this.updateReportFilters.high_potential_emp : undefined
      };
      const filters = Object.assign({}, this.updateReportFilters);
      if (filters && filters.filters) {
        // filters.filters have the dynamic filters value
        delete filters.filters;
      }
      if (this.updateReportFilters && this.updateReportFilters.filters) {
        this.$lodash.each(this.updateReportFilters.filters, (v, k) => {
          if (v.length > 0 && k !== 'session__stage__title') {
            queryParams[`user__profile__${k}__in`] = v.join();
          } else {
            queryParams.stage__title__in = v.join();
          }
        });
      }
      axios.get(`${process.env.VUE_APP_API_URL}reports/get_diversity_report`, {
        params: queryParams
      }).then((response) => {
        if (response && response.data) {
          this.overtimeTableData = response.data.datewise_sorted_gender_enagagement_report;
          this.overtimeBarData = response.data.datewise_gender_enagagement_report;
          this.overallEngagements = response.data.overall_gender_engagement;
          this.overallParticipation = response.data.genderwise_participation_rate;
          this.overtimeTableData = response.data.datewise_sorted_gender_enagagement_report;
          this.reportDates = response.data.report_dates;
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get report, Please try again later!'
          });
        }
      });
    },
    onClickSortByDrivers (val) {
      const queryParams = {
        sort_key: val || undefined,
        fields: 'driverwise_sorted_report',
        initiated_date_start: this.updateReportFilters && this.updateReportFilters.initiated_date_start ? this.updateReportFilters.initiated_date_start : undefined,
        initiated_date_end: this.updateReportFilters && this.updateReportFilters.initiated_date_end ? this.updateReportFilters.initiated_date_end : undefined,
        // initiated_date_start: this.reportDate.start,
        // initiated_date_end: this.reportDate.end,
        user__profile__high_potential_emp: this.updateReportFilters ? this.updateReportFilters.high_potential_emp : undefined
      };
      const filters = Object.assign({}, this.updateReportFilters);
      if (filters && filters.filters) {
        // filters.filters have the dynamic filters value
        delete filters.filters;
      }
      if (this.updateReportFilters && this.updateReportFilters.filters) {
        this.$lodash.each(this.updateReportFilters.filters, (v, k) => {
          if (v.length > 0 && k !== 'session__stage__title') {
            queryParams[`user__profile__${k}__in`] = v.join();
          } else {
            queryParams.stage__title__in = v.join();
          }
        });
      }
      axios.get(`${process.env.VUE_APP_API_URL}reports/get_diversity_report`, {
        params: queryParams
      }).then((response) => {
        if (response && response.data) {
          this.driverBarData = response.data.driverwise_gender_enagagement_report;
          this.driverTableData = response.data.driverwise_sorted_gender_enagagement_report;
          this.reportDrivers = response.data.report_drivers;
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get report, Please try again later!'
          });
        }
      });
    },
    getSortOptions () {
      const queryParams = {
        options: 'sort_option,filter_options'
      };
      axios.get(`${process.env.VUE_APP_API_URL}reports/get_report_options`, {
        params: queryParams
      }).then((response) => {
        if (response && response.data) {
          this.filterOptions = response.data.queryset_filter_options;
          this.sortOptions = response.data.queryset_sort_options;
          if (this.sortOptions) {
            delete this.sortOptions.gender;
          }
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get filter, Please try again later!'
          });
        }
      });
    },
    getDiversityReport (type) {
      console.log(this.updateReportFilters);
      const queryParams = {
        sort_key: type || undefined,
        fields: 'datewise_sorted_report,driverwise_sorted_report',
        initiated_date_start: this.updateReportFilters && this.updateReportFilters.initiated_date_start ? this.updateReportFilters.initiated_date_start : undefined,
        initiated_date_end: this.updateReportFilters && this.updateReportFilters.initiated_date_end ? this.updateReportFilters.initiated_date_end : undefined,
        // initiated_date_start: this.reportDate.start,
        // initiated_date_end: this.reportDate.end,
        segment_filter: this.updateReportFilters && this.updateReportFilters.segment_filter ? this.updateReportFilters.segment_filter : undefined,
        user__profile__high_potential_emp: this.updateReportFilters ? this.updateReportFilters.high_potential_emp : undefined
      };
      const filters = Object.assign({}, this.updateReportFilters);
      if (filters && filters.filters) {
        // filters.filters have the dynamic filters value
        delete filters.filters;
      }
      if (this.updateReportFilters && this.updateReportFilters.filters) {
        this.$lodash.each(this.updateReportFilters.filters, (v, k) => {
          if (v.length > 0 && k !== 'session__stage__title') {
            queryParams[`user__profile__${k}__in`] = v.join();
          } else {
            queryParams.stage__title__in = v.join();
          }
        });
      }
      /*eslint-disable*/
      if (this.updateReportFilters && this.updateReportFilters.user__profile__high_potential_emp) {
        queryParams['high_potential_emp'] = true;
      }
      axios.get(`${process.env.VUE_APP_API_URL}reports/get_diversity_report`, {
        params: queryParams
      }).then((response) => {
        if (response && response.data) {
          // console.log('response.data', response.data);
          this.overtimeBarData = response.data.datewise_gender_enagagement_report;
          this.overallEngagements = response.data.overall_gender_engagement;
          this.overallParticipation = response.data.genderwise_participation_rate;
          this.overtimeTableData = response.data.datewise_sorted_gender_enagagement_report;
          this.driverBarData = response.data.driverwise_gender_enagagement_report;
          this.driverTableData = response.data.driverwise_sorted_gender_enagagement_report;
          this.updateReportFilterss = response.data.report_dates;
          this.reportDrivers = response.data.report_drivers;
          this.reportDates = response.data.report_dates;
          // this.filterOptions = response.data.queryset_filter_options;
          // this.sortOptions = response.data.queryset_sort_options;
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get report, Please try again later!'
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.diversity-report-wrap {
  .diversity-report-heading {
    margin: 0;
    .diversity-report-title {
      color: var(--color-text);
      // font-size: var(--content-size);
      font-size: var(--stats-size-1);
    }
    .diversity-report-sub {
      color: var(--color-text);
      font-size: var(--content-size);
      padding: 8px 0;
    }
  }
  .report-container {
    background-color: var(--bg);
    // height: 74vh;
    // overflow: hidden;
    // border-radius: 12px;
    margin: 0 12px;
    .report-wrap {
      // margin: 0 20px;
      // padding: 0 20px;
      // height: 70vh;
      // overflow-y: auto;
      // overflow-x: hidden;
      .bar-wrap {
        // display: grid;
        // grid-template-columns: 1fr;
        margin-top: 20px;
        .report-title {
          padding-bottom: 14px;
          color: var(--color-text);
          font-size: var(--heading-size);
          font-weight: var(--heading-weight);
        }
        .report-bar-graph {
          // margin-right: 10px;
          display: grid;
          grid-template-columns: 2fr 5fr;
          height: 450px;
          background: var(--bg);
          box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06),0 4px 8px rgba(0, 0, 0, 0.1) !important;
          border-radius: 0.5rem;
        }
        .overtime-table {
          background-color: var(--bg);
          box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06),0 4px 8px rgba(0, 0, 0, 0.1) !important;
          margin: 20px 0;
          display: grid;
          grid-template-columns: 1fr;
          // border-radius: 0.5rem;
          overflow: hidden;
          padding: 16px;
        }
        .driver-reports {
          .report-title {
            padding: 16px 0 6px 0;
            color: var(--color-text);
            font-size: var(--heading-size);
            font-weight: var(--heading-weight);
          }
          .driver-bar-graph {
            margin: 20px 0;
            display: grid;
            grid-template-columns: 5fr 4fr;
            // height: 600px;
            background: var(--bg);
            border-radius: 0.5rem;
          }
          .driver-table {
            margin: 20px 0;
            display: grid;
            grid-template-columns: 1fr;
            // border-radius: 0.5rem;
            overflow: hidden;
          }
        }
      }
      .report-trend-graph {
        margin-top: 20px;
        padding: 30px 30px;
        height: 600px;
        background: var(--bg);
        border-radius: 0.5rem;
        .trends-title {
          display: grid;
          place-items: center;
          padding-bottom: 16px;
          margin-top: -16px;
          color: var(--color-text);
          font-size: var(--heading-size);
          font-weight: var(--heading-weight);
        }
      }
    }
    .no-report-data {
      display: grid;
      grid-template-columns: 1fr;
      background-color: var(--bg);
      align-items: center;
      justify-items: center;
      margin: 50px;
      border-radius: 1rem;
      height: 300px;
      .sad-amara {
        text-align: center;
        img {
          width: 25%;
          border-radius: 100%;
        }
      }
      .am-text {
        font-size: var(--heading-size);
        color: var(--color-text);
      }
    }
    .intro-x {
      opacity: 0;
      position: relative;
      transform: translateX(80px);
      animation: 0.6s intro-x-animation ease-in-out 0.33333s;
      animation-fill-mode: forwards;
      animation-delay: 0.3s;
    }
    @keyframes intro-x-animation {
      100% {
        opacity: 1;
        transform: translateX(0px);
      }
    }
  }
}
</style>
